export const ADMIN = "ADMIN";
export const FACULTY = "FACULTY";
export const USER = "USER";
export const STAFF = "STAFF";
export const TOUR = "TOUR";
